import { cn } from 'src/helpers/style'

import { Typography, TypographyVariant } from 'src/components/atoms'

export interface IFilterPillOption<T extends string = string> {
  value: T
  label: string
}

export interface IFilterPillsProps<T extends string = string> {
  value: T
  options: IFilterPillOption<T>[]
  onChange: (value: T) => void
  ariaLabel?: string
  className?: string
}

export const FilterPills = <T extends string = string>({
  value,
  options,
  onChange,
  ariaLabel,
  className,
}: IFilterPillsProps<T>): JSX.Element => (
  <div
    role="tablist"
    aria-label={ariaLabel}
    className={cn('flex items-center gap-4', className)}
  >
    {options.map(option => {
      const isActive = option.value === value
      return (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(option.value)}
          className={cn(
            'flex items-center justify-center rounded-[12px] px-3 py-1 transition-colors duration-200',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-content-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-page',
            isActive
              ? 'bg-state-hover-fill'
              : 'bg-transparent hover:bg-state-hover-surface',
          )}
        >
          <Typography
            variant={
              isActive
                ? TypographyVariant.bodyXsStrong
                : TypographyVariant.bodyXs
            }
            className="leading-[1.45]"
          >
            {option.label}
          </Typography>
        </button>
      )
    })}
  </div>
)
